import React from "react";
import { t } from "ttag";

import { SplitTestimonialCarouselBlock } from "@reactivated";

import { RichText } from "../RichText";
import { SplitCarousel } from "../SplitCarousel";

import styles from "./SplitTestimonialCarousel.module.scss";

export const SplitTestimonialCarousel = ({
    value,
}: {
    value: SplitTestimonialCarouselBlock;
}) => (
    <SplitCarousel
        slides={value.slides ?? []}
        moduleTheme={value.module_theme}
        cardTheme={value.card_color_theme}
        ariaLabel={t`Testimonials`}
        textPanelClassName={styles.panelPadding}
        renderTextPanel={(slide) => (
            <div className={styles.textPanel}>
                <blockquote className={styles.quote}>
                    <div className={styles.quoteText}>
                        <span className={styles.openQuote} aria-hidden="true">
                            &ldquo;
                        </span>
                        {slide.quote && (
                            <RichText
                                value={slide.quote}
                                blockOverrides={{ unstyled: "p" }}
                            />
                        )}
                    </div>
                </blockquote>
                <div className={styles.attribution}>
                    <p className={styles.name}>{slide.name}</p>
                    {(slide.position || slide.company) && (
                        <p className={styles.positionCompany}>
                            {slide.position}
                            {slide.position && slide.company && ", "}
                            {slide.company}
                        </p>
                    )}
                    {slide.lean_in_status && (
                        <p className={styles.leanInStatus}>
                            {slide.lean_in_status}
                        </p>
                    )}
                </div>
            </div>
        )}
    />
);
